import get from 'lodash/get';
import { retrieveQueryString } from '../../query';
import { ensureDatesAreValid } from '../../../modules/dates';
import { getViewData } from '../../../modules/view-data';
import moment from '../../../modules/moment';

const searchData = retrieveQueryString();
const rental = getViewData('unconfirmed_reservation.rental') || getViewData('booking.rental') || searchData.rental || getViewData('searchParams.default_search_rental', 'long');
const bookingData = ensureDatesAreValid({
    key: 1,
    id: null,
    rental,
    start_date: getViewData('unconfirmed_reservation.start_date') || searchData.start_date || moment().format('DD-MM-YYYY'),
    start_time: getViewData('unconfirmed_reservation.start_time') || searchData.start_time || moment().format('HH:mm'),
    end_date: getViewData('unconfirmed_reservation.end_date') || searchData.end_date || moment().format('DD-MM-YYYY'),
    end_time: getViewData('unconfirmed_reservation.end_time') || searchData.end_time || moment().format('HH:mm'),
    voucher_id: null,
    created_at: null,
    quote: {
        value: null,
        deposit: null,
    },
    reservation: {
        reservation_id: null,
        price: null,
        price_before_discount: null,
        discounted_value: null,
    },
    errors: [],
    serviceFeesStatus: false,
});
delete bookingData.rental;

// Initial state
export default {
    space: get(window.YPS, 'space', {
        lt_season_pricing: {
            data: [],
        },
        lt_monthly_instalments_enabled: false,
    }),

    // Reservation step data
    reservation_details: {
        bookings: [bookingData],
        rental,
        interval_count: parseFloat(getViewData('unconfirmed_reservation.interval_count') || getViewData('booking.interval_count', searchData.interval_count)) || 1,
        vehicle_registration: null,
        next_billing_date: getViewData('booking.next_billing_date'),
        voucher: {
            id: null,
            name: null,
            label: null,
            discounted_value: null,
        },
        permit_address: {
            display_name: null,
            address_1: null,
            address_2: null,
            city: null,
            postcode: null,
        },
        errors: [],
        booking_type: 'now',
        duration: null,
        season_plan: getViewData('booking.season_plan'),
    },

    // Account information step data
    account_information: {
        customer_type: null,
        user: {
            first_name: get(window.YPS, 'user.first_name', null),
            last_name: get(window.YPS, 'user.last_name', null),
            mobile: get(window.YPS, 'user.mobile', null),
            email: get(window.YPS, 'user.email', null),
            password: null,
            password_confirmation: null,
            impersonating: get(window.YPS, 'user.impersonating', false),
            admin: get(window.YPS, 'user.admin', false),
            marketing_consent_given: false,
        },
        vehicle: get(window.YPS, 'vehicle', {
            id: null,
            registration_number: null,
            reference: null,
            custom_data: {
                make: '',
                model: '',
                registration_number: '',
                image: '',
                colour: '',
            },
        }),
        vehicle_not_known: false,
        vehicles: [],
    },

    // Payment information step data
    payment_information: {
        cards: [],

        card: {
            id: null,
            number: null,
            cvc: null,
            expiry: null,
            reference: null,
            selected_id: null,
        },
        payment_type: 'card',
    },

    // States
    loading: false,
    submitting: false,
    booking_successful: false,
    serviceFeesStatus: false,
    serviceFee: 0,
    source: getViewData('booking.source', null),
    pay_in_monthly_instalments: getViewData('booking.pay_in_monthly_instalments'),

    states: {
        cancel_booking: null,
        update_end_date: null,
        update_start_date: null,
        change_vrn: null,
    },

    // Determine whether steps are visible and can be toggled
    activeStep: 'reservationDetails',
    validSteps: {
        reservationDetails: false,
        accountInformation: false,
        paymentInformation: false,
    },

    // is the booking over a day long
    overDay: false,

    // Get the products list
    products: [],
};
